import LinkExpand from 'components/LinkExpand';
import './style.scss';
import AgreementContent from '../AgreementContent';
import { AgreementProps } from '../type';

const AgreementLink: React.FC<AgreementProps> = props => {
    const {
        title,
        id,
        content,
        modalOptions: { modalClassName, modalContent, btnOk, ...restModalOptions } = {},
        linkCode,
        ...restProps
    } = props;

    return (
        <LinkExpand
            title={title}
            modalOptions={{
                modalClassName: 'agreement-modal',
                modalContent: <AgreementContent linkCode={linkCode} id={id} content={content} />,
                btnOk: __('我已阅读此协议'),
                centered: true,
                ...restModalOptions
            }}
            {...restProps}
        />
    );
};

export default AgreementLink;
